import {testIdProps} from '@github-ui/test-id-props'
import {forwardRef} from 'react'

import styles from './omnibar-drawer.module.css'

type Props = {
  horizontalScrollbarSize?: number | null
}

/**
 * Render an invisible "drawer" for the Omnibar to appear in from.
 *
 * The Omnibar drawer is similar to the showing and hiding dock in macOS,
 * except that when in the "down" position, just the top of the Omnibar is
 * still visible.
 *
 * See docs/omnibar.md for more info.
 */
export const OmnibarDrawer = forwardRef<HTMLDivElement, React.PropsWithChildren<Props>>(
  ({horizontalScrollbarSize, children}, ref) => {
    const effectiveScrollbarSize = horizontalScrollbarSize ?? 12
    return (
      <div
        ref={ref}
        style={{
          bottom: horizontalScrollbarSize ? `${effectiveScrollbarSize}px` : 0,
        }}
        className={styles.OmnibarDrawerContainer}
        {...testIdProps('omnibar-drawer')}
      >
        {children}
      </div>
    )
  },
)

OmnibarDrawer.displayName = 'OmnibarDrawer'
